import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const NetworkFilters = ({ filters, onFilterChange }) => {
  const performanceLevelOptions = [
    { value: 'all', label: 'Todos los Niveles' },
    { value: 'level1', label: 'Nivel 1 (10%)' },
    { value: 'level2', label: 'Nivel 2 (4%)' },
    { value: 'level3', label: 'Nivel 3 (0.6%)' },
    { value: 'level4', label: 'Nivel 4 (0.4%)' }
  ];

  const activityStatusOptions = [
    { value: 'all', label: 'Todos los Estados' },
    { value: 'active', label: 'Activos' },
    { value: 'inactive', label: 'Inactivos' }
  ];

  const registrationPeriodOptions = [
    { value: 'all', label: 'Todo el Tiempo' },
    { value: 'thisMonth', label: 'Este Mes' },
    { value: 'lastMonth', label: 'Mes Pasado' },
    { value: 'last3Months', label: 'Últimos 3 Meses' },
    { value: 'last6Months', label: 'Últimos 6 Meses' },
    { value: 'thisYear', label: 'Este Año' }
  ];

  return (
    <div className="card p-4 md:p-5 lg:p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Nivel de Red"
          options={performanceLevelOptions}
          value={filters?.performanceLevel}
          onChange={(value) => onFilterChange('performanceLevel', value)}
        />

        <Select
          label="Estado de Actividad"
          options={activityStatusOptions}
          value={filters?.activityStatus}
          onChange={(value) => onFilterChange('activityStatus', value)}
        />

        <Select
          label="Período de Registro"
          options={registrationPeriodOptions}
          value={filters?.registrationPeriod}
          onChange={(value) => onFilterChange('registrationPeriod', value)}
        />

        <Input
          type="search"
          label="Buscar Referido"
          placeholder="Nombre o código..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default NetworkFilters;